"use client";

import { createContext, type ReactNode, use } from "react";

/*
 * Section titles are h2 under the page's h1. A screen that nests sections (Install: platform,
 * Try it, a step, the settings inside it) wraps each deeper level in NestedSections so screen
 * reader heading navigation can tell them apart.
 */

type Level = 2 | 3 | 4 | 5 | 6;

const HeadingLevel = createContext<Level>(2);

/** The tag for a PageSection or SettingsSection title at this depth. */
export function useSectionHeading() {
	return `h${use(HeadingLevel)}` as const;
}

/** Section titles inside sit one heading level below the section around them. */
export function NestedSections({ children }: { children: ReactNode }) {
	const level = use(HeadingLevel);
	return (
		<HeadingLevel value={Math.min(level + 1, 6) as Level}>
			{children}
		</HeadingLevel>
	);
}
